/* istanbul ignore file */
import { IGetItemsParams } from '../../models/httpClient/IListFetcher';
import { IRequest } from '../../models/httpClient/IRequest';
import {
  GetDatabasesResult,
  GetDataSourcesResult,
  GetProjectsResult,
  GetTablesResult,
  GetFlowsResult,
  GetLensesResult,
  GetMetricsResult,
  GetViewsResult,
  GetWorkbooksResult,
  GetDataRolesResult,
  GetVirtualConnectionsResult,
  GetUsersResult,
  GetPredictiveModelsResult,
} from '../../models/httpClient/MetaDataResults';
import { Request } from '../../models/httpClient/Request';

namespace GetMetaDataRequests {
  export class GetWorkbooksRequest
    extends Request<IGetItemsParams, GetWorkbooksResult>
    implements IRequest<IGetItemsParams, GetWorkbooksResult>
  {
    constructor(params: IGetItemsParams) {
      super('getWorkbooks', params);
    }
  }

  export class GetViewsRequest extends Request<IGetItemsParams, GetViewsResult> implements IRequest<IGetItemsParams, GetViewsResult> {
    constructor(params: IGetItemsParams) {
      super('getViews', params);
    }
  }

  export class GetMetricsRequest extends Request<IGetItemsParams, GetMetricsResult> implements IRequest<IGetItemsParams, GetMetricsResult> {
    constructor(params: IGetItemsParams) {
      super('getMetrics', params);
    }
  }

  export class GetDatabasesRequest
    extends Request<IGetItemsParams, GetDatabasesResult>
    implements IRequest<IGetItemsParams, GetDatabasesResult>
  {
    constructor(params: IGetItemsParams) {
      super('getDatabases', params);
    }
  }

  export class GetVirtualConnectionsRequest
    extends Request<IGetItemsParams, GetVirtualConnectionsResult>
    implements IRequest<IGetItemsParams, GetVirtualConnectionsResult>
  {
    constructor(params: IGetItemsParams) {
      super('getPublishedConnections', params);
    }
  }

  export class GetTablesRequest extends Request<IGetItemsParams, GetTablesResult> implements IRequest<IGetItemsParams, GetTablesResult> {
    constructor(params: IGetItemsParams) {
      super('getTables', params);
    }
  }

  export class GetProjectsRequest
    extends Request<IGetItemsParams, GetProjectsResult>
    implements IRequest<IGetItemsParams, GetProjectsResult>
  {
    constructor(params: IGetItemsParams) {
      super('getProjects', params);
    }
  }

  export class GetDataSourcesRequest
    extends Request<IGetItemsParams, GetDataSourcesResult>
    implements IRequest<IGetItemsParams, GetDataSourcesResult>
  {
    constructor(params: IGetItemsParams) {
      super('getDatasources', params);
    }
  }

  export class GetLensesRequest extends Request<IGetItemsParams, GetLensesResult> implements IRequest<IGetItemsParams, GetLensesResult> {
    constructor(params: IGetItemsParams) {
      super('getLenses', params);
    }
  }

  export class GetFlowsRequest extends Request<IGetItemsParams, GetFlowsResult> implements IRequest<IGetItemsParams, GetFlowsResult> {
    constructor(params: IGetItemsParams) {
      super('getFlows', params);
    }
  }

  export class GetPredictiveModelsRequest extends Request<IGetItemsParams, GetPredictiveModelsResult> implements IRequest<IGetItemsParams, GetPredictiveModelsResult> {
    constructor(params: IGetItemsParams) {
      super('getPredictiveModels', params);
    }
  }

  export class GetDataRoleRequest
    extends Request<IGetItemsParams, GetDataRolesResult>
    implements IRequest<IGetItemsParams, GetDataRolesResult>
  {
    constructor(params: IGetItemsParams) {
      super('getDataRoles', params);
    }
  }

  export class GetUsersRequest extends Request<IGetItemsParams, GetUsersResult> {
    constructor(params: IGetItemsParams) {
      super('getUsers', params);
    }
  }
}

export default GetMetaDataRequests;
